import React from 'react'

const ShowPressSource = ({ pressSource }) => (
  <div className='article-pressSource'>

    {(pressSource.length > 0) ? (
      <div><strong>Source(s): </strong></div>
    ) : null}

    <div>

      {(pressSource.length > 0)
        ? pressSource.map(file => (<div className='presSource-item' key={file.id}>
          {file.note === ''
            ? file.title
            : <a href={file.note} rel='noopener noreferrer' target='_self'>{file.title}</a>}
        </div>)
        ) : null}
    </div>

  </div>
)

export default ShowPressSource
